import type { Persona } from "../aidwops.types";

export type AidwopsView = Persona | "graph" | "expert-queue";

interface Props {
    active: AidwopsView;
    onChange: (_value: AidwopsView) => void;
}

export function PersonaRail({ active, onChange }: Props) {
    return (
        <nav className="rail" aria-label="Agent switcher">
            <button
                className={`rail-item${active === "all" ? " active" : ""}`}
                title="All agents"
                onClick={() => onChange("all")}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect
                        x="3"
                        y="3"
                        width="7"
                        height="7"
                        rx="1.5"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    />
                    <rect
                        x="14"
                        y="3"
                        width="7"
                        height="7"
                        rx="1.5"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    />
                    <rect
                        x="3"
                        y="14"
                        width="7"
                        height="7"
                        rx="1.5"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    />
                    <rect
                        x="14"
                        y="14"
                        width="7"
                        height="7"
                        rx="1.5"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    />
                </svg>
            </button>
            <span className="rail-label" onClick={() => onChange("all")}>Agentic Insights</span>
            <div className="rail-sep" />

            <button
                className={`rail-item${active === "zscaler" ? " active" : ""}`}
                title="Zscaler agent"
                onClick={() => onChange("zscaler")}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M12 3 4 6.5V12c0 5 3.4 8.7 8 9.6 4.6-.9 8-4.6 8-9.6V6.5L12 3Z"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
            <span className="rail-label" onClick={() => onChange("zscaler")}>Zscaler Agent Insights</span>

            <button
                className={`rail-item${active === "intune" ? " active" : ""}`}
                title="Intune agent"
                onClick={() => onChange("intune")}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect
                        x="5"
                        y="2"
                        width="14"
                        height="20"
                        rx="2.4"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    />
                    <path
                        d="M10 18h4"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                    />
                </svg>
            </button>
            <span className="rail-label" onClick={() => onChange("intune")}>Intune Agent Insights</span>

            <div className="rail-sep" />
            <button
                className={`rail-item${active === "graph" ? " active" : ""}`}
                title="Service graph"
                onClick={() => onChange("graph")}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <circle
                        cx="6"
                        cy="6"
                        r="2.4"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    />
                    <circle
                        cx="18"
                        cy="6"
                        r="2.4"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    />
                    <circle
                        cx="12"
                        cy="18"
                        r="2.4"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    />
                    <path
                        d="m8.1 7.1 2 8.4M15.9 7.1l-2 8.4M8.4 6h7.2"
                        stroke="currentColor"
                        strokeWidth="1.6"
                    />
                </svg>
            </button>
            <span className="rail-label" onClick={() => onChange("graph")}>Agent Topology</span>

            <button
                className={`rail-item${active === "expert-queue" ? " active" : ""}`}
                title="Expert queue"
                onClick={() => onChange("expert-queue")}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M9 11.5 11.2 14 16 8.5"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6 3.5h12a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2Z"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    />
                    <path
                        d="M8 3v3M16 3v3"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                    />
                </svg>
                <span className="badge warn" />
            </button>
            <span className="rail-label" onClick={() => onChange("expert-queue")}>Expert Queue</span>
        </nav>
    );
}
